import { FC, useEffect, useState } from "react"
import Breadcrumb from "../../../components/common/Breadcrumbs";
import { useFindUserSettingsByGroupNameQuery } from "../../../components/common/userSetting/userSettingsApi";
import { createClickableLink } from "../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../components/common/datatable/filter/SearchInputWrapper";
import { SearchSelectWithEnum } from "../../../components/common/datatable/filter/SearchSelectWrapper";
import { DataTable } from "../../../components/common/datatable/DataTable";
import {
    useLazyExportLinkedAccountDataQuery,
    useSearchLinkedAccountsQuery
} from "./linkedAccountsApi";
import IconButton from "../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { DataTableColumn } from "../../../components/common/datatable/DataTableTypes";
import { getEnumDisplayNameByConstant } from "../../../helpers/utils/EnumUtils";
import { useGetEnumsQuery } from "../../../app/globalApi";
import CollectorSearchInputWrapper from "../../../components/common/datatable/filter/CollectorSearchInputWrapper";


const LinkedAccounts: FC = () => {

    const navigate = useNavigate()

    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Linked Accounts", url: "" },

    ])

    useEffect(() => {
        document.title = "Linked Accounts";
    });

    const { data: userSettings } = useFindUserSettingsByGroupNameQuery("Linked Account");
    const [triggerExportLinkedAccountDataQuery] = useLazyExportLinkedAccountDataQuery();
    const { data: enums } = useGetEnumsQuery("");

    // @ts-ignore
    const columns: DataTableColumn[] = [
        {
            label: "Account No.",
            accessor: "accountNumber",
            cell: (props: any) => {
                let path = `/linked-accounts/${props.row.original.id}`;
                return createClickableLink(path, props.value, userSettings, false, "", ["LINKACC-R"]);
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Account Number..."} name={"Account Number"}
                    accessor={"accountNumber"} />,
            }]
        },

        {
            label: "Linked Account No.(s)", accessor: "linkedAccountNumbers",
            canSort: false,
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Linked Account No..."} name={"Account Number"}
                    accessor={"linkedAccountNumber"} />,
                overrideFilterLabel: "Linked Account No.",
            }]
        },
        {
            label: "Collector", accessor: "collector", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                return (<span>{props.row.original.collector.name}</span>)
            },
            filterOptions: [{
                filterComponent: <CollectorSearchInputWrapper accessor="collectorId" />,
                overrideFilterAccessor: "collectorId",
                overrideFilterLabel: "Collector",
            }]
        },
        {
            label: "Category", accessor: "category",
            cell: (props: any) => {
                return <>
                    <span>{getEnumDisplayNameByConstant(enums?.["LinkCategory"], props.value)}</span>

                </>
            },
            filterOptions: [{
                filterComponent: SearchSelectWithEnum(enums?.["LinkCategory"], "Select Category...", false, "category", null),
            }]
        },
    ]

    return (

        <div className="user-container px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchLinkedAccountsQuery,
                    exportAction: triggerExportLinkedAccountDataQuery
                }}
                userSettingGroup={"Linked Account"}
                defaultSortOptions={{
                    accessor: "accountNumber",
                    direction: "asc"
                }}
                
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}
                            onClick={() => {
                                navigate("/linked-accounts/create")
                            }}
                            title={"Create Linked Account"}
                        />,
                        permissions: ["LINKACC-C"]
                    
                    },
                    
                }}
                basePermission={"LINKACC"}
            />

        </div>

    )
}
export default LinkedAccounts